import { render, staticRenderFns } from "./MetricRecordCreate.vue?vue&type=template&id=5255ed71"
import script from "./MetricRecordCreate.vue?vue&type=script&lang=js"
export * from "./MetricRecordCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports